import isNil from 'lodash/isNil';

import { FeatureToggleEnum } from '@nocowanie/core/enums';

import { environment } from '@app/environments/environment';

const FT_ENV_MAP: Partial<Record<FeatureToggleEnum, string>> = {
    [FeatureToggleEnum.USE_HOME_PAGE_ES_VERSION]: 'HOME_PAGE_ES_VERSION',
};

export const getFeatureToggleEnvValue = <T = unknown>(ft: FeatureToggleEnum): T | undefined => {
    const envKey = FT_ENV_MAP[ft];
    if (isNil(envKey)) {
        return undefined;
    }

    return (environment as Record<string, unknown>)[envKey] as T;
};
